import { reportStore } from './root_store';
import {
  BC06DataChart,
  DataSummaryReportProduction,
  EquipmentOfBarCodeModel,
  EquipmentStatusReportModel,
  ListKeynValue,
  WorkShopEquipmentsModel,
  BC03,
  BC07TimeMachineTroubled,
  BC07DataChart,
  WoQCProductionModel,
  QCProductionModel,
  WoCompleteModel,
  BC06Details,
  BC09CompleteRateStage,
  BC05,
  BC05Details,
  BC04,
  BC04Chart,
  BC07,
  BC08Model,
  BC04Model,
  BC02,
  BC02PopupModel,
  BC02DropdownModel,
  BC05Model,
} from 'services/report_services';
import { observable, runInAction } from 'mobx';
import {
  IReportService,
  EquipmentStatusModel,
  DetailTimeMachineTroubledReport,
  BC08,
  Department,
} from './../services/report_services';
import { DataResponse } from 'services/response';

export type ReportStore = {
  // bc01
  equipmentStatus: {
    data: Array<EquipmentStatusModel>;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
  stateItemId: string[];
  listKeynValue: {
    data: Array<ListKeynValue>;
    message: string;
    isSuccess: boolean;
  };
  WorkShopEquipmentsStatus: {
    data: Array<WorkShopEquipmentsModel>;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };

  ListEquipmentOfBarCode: {
    code: number;
    data: Array<EquipmentOfBarCodeModel>;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
  UpdateResponse: {
    message: string;
    isSuccess: boolean;
  };
  SaveResponse: {
    message: string;
    isSuccess: boolean;
  };
  EquipmentStatusReportResponse: {
    code: number;
    data: EquipmentStatusReportModel | undefined;
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };

  //BC06
  SumaryProductionReportResponse: {
    code: number;
    data: DataSummaryReportProduction | undefined;
    dataChart: BC06DataChart[];
    message?: any;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  //BC06 details response
  BC06DetailsResponse: {
    code: number;
    data: BC06Details | undefined;
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  // ================================================================================
  // ================================================================================
  //BC02
  BC02Response: DataResponse<BC02 | undefined>;
  // BC02 popup
  BC02PopupResponse: DataResponse<BC02PopupModel | undefined>;
  // BC02 dropdown
  BC02DropdownResponse: BC02DropdownModel;

  // ================================================================================
  // ================================================================================
  //BC03 Báo cáo cảnh báo tiến độ đơn hàng
  BC03Response: DataResponse<Array<BC03>>;
  //BC07
  TimeMachineTroubledReportRespone: {
    code: number;
    data: BC07TimeMachineTroubled[];
    dataChart: BC07DataChart | undefined;
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  //BC07 DETAILS
  DetailTimeMachineTroubledReportResponse: {
    code: number;
    data: DetailTimeMachineTroubledReport | undefined;
    dataChart: any;
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  // BC08
  BC08Response: {
    code: number;
    data: BC08[];
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  //BC09
  BC09CompleteRateStageResponse: {
    code: number;
    data: BC09CompleteRateStage[];
    message: '';
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  // ================================================================================================
  // --------------------BÁO CÁO MỚI
  // BC07 mới (thay cho bc08 + bc09)
  BC07Response: DataResponse<Array<BC07>>;
  // BC08 mới (thay cho bc 10)
  BC08NewResponse: DataResponse<Array<BC08Model>>;
  // BC04 mới
  BC04NewResponse: DataResponse<Array<BC04Model>>;
  //
  BC05NewResponse: DataResponse<BC05Model | undefined>;
  // ===============================================================================================
  //--BC11-------------------------------------------------------------------------------------
  qcProcductionResponse: {
    isSuccess: boolean;
    data: WoQCProductionModel[];
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  detailQCResponse: {
    data: QCProductionModel[];
    isSuccess: boolean;
  };
  //-------------------------------------------------------------------------------------------
  //-------BC10------------------------------------------------------------------------------------
  woCompleteResponse: {
    isSuccess: boolean;
    data: WoCompleteModel[];
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  //----------------------------------------------------------------------------------------
  //BC05
  BC05Response: {
    code: number;
    data: BC05[];
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  // BC05
  BC05DetailsResponse: {
    code: number;
    data: BC05Details[];
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  // BC04
  BC04Response: {
    code: number;
    data: BC04[];
    dataChart: BC04Chart | undefined;
    message: string;
    isSuccess: boolean;
    resultsCount: number;
    recordsTotal: number;
    pagesCount: number;
  };
  // bc04 department
  DepartmentResponse: {
    data: Array<Department>;
    message: string;
    isSuccess: boolean;
  };
};

export interface IReportResenter {
  createStore(): ReportStore;
  getEquipmentStatusReport(store: ReportStore, data: object): Promise<void>;
  getListWorkShop(store: ReportStore): Promise<void>;
  exportExcelBC11(): Promise<void>;
  WorkShopEquipments(
    store: ReportStore,
    WorkShopId?: string | null,
    MachineGroup?: string[] | null,
    MachineStatus?: string | null,
    EuipmentName?: string[] | null,
    Actived?: boolean | null,
    equipmentCardIds?: string[]
  ): Promise<void>;
  getDropdownDepartment(store: ReportStore, id: string | null): Promise<void>;
  //BC01
  getListDropdownEquipmentName(store: ReportStore, key: string): Promise<void>;
  getListEquipmentOfBarCode(store: ReportStore, id: string): Promise<void>;
  updateBarCodeNameEquip(store: ReportStore, data: object): Promise<void>;
  updateIndexBarcode(store: ReportStore, data: object): Promise<void>;
  getListEquipmentStatus(store: ReportStore): Promise<void>;
  getListGroupEquip(store: ReportStore, listId: string[]): Promise<void>;
  getEquipmentStatusById(store: ReportStore, data: object): Promise<void>;
  // ============================================================================================================
  // ============================================================================================================
  exportExcelBC01(data: object): Promise<void>;
  // BC02
  getListEquipCard(store: ReportStore): Promise<void>;
  // BC02 (NEW)
  getBC02(store: ReportStore, data: object): Promise<void>;
  // export data bc02
  exportDataBC02(data: object): Promise<void>;
  // BC02 popup
  getDataPopupBC02(store: ReportStore, workOrderId: string): Promise<void>;
  // BC02 Dropdown danh sách máy theo công đoạn
  getDropdownBC02(store: ReportStore, StepCode: string, equipmentName?: string): Promise<void>;
  // BC02 save chọn máy thực hiện
  saveChooseEquipment(store: ReportStore, data: object): Promise<void>;

  // BC02 sắp xếp danh sách lệnh sản xuất đang thực hiện
  sortRowBC02Selected(store: ReportStore, data: object): Promise<void>;

  updateWoCard(store: ReportStore, data: object): Promise<void>;
  // ============================================================================================================
  // ============================================================================================================
  setItemId(store: ReportStore, id: string[]): Promise<void>;
  sumaryProductionReport(store: ReportStore, data: object): Promise<void>;
  //bc06 details
  getBC06Details(store: ReportStore, equipId: string, fromTime: string, toTime: string): Promise<void>;

  //BC03/ Báo cáo cảnh báo tiến độ đơn hàng
  getDataBC03(store: ReportStore, data: object): Promise<void>;
  exportExcelBC03(data: object): Promise<void>;

  //BC07
  getBC07TimeMachineTroubledReport(store: ReportStore, data: object): Promise<void>;
  getBC07DetailTimeMachineTroubledReport(
    store: ReportStore,
    EquipmentCardId: string,
    FromTime?: string,
    ToTime?: string,
  ): Promise<void>;
  //BC07 list equiment name
  getBC07ListEquipcard(store: ReportStore, data: object): Promise<void>;
  // BC08
  getBC08(store: ReportStore, data: object): Promise<void>;
  //BC09
  getBC09CompleteRateStage(store: ReportStore, data: object): Promise<void>;
  //bc09
  getDropdownWo(store: ReportStore, woCode: string): Promise<void>;
  // ========================================================================================
  // ---------------------------------------------------------------------------------------
  //------------------ BÁO CÁO MỚI
  // BC07 (mới)
  getDataBC07(store: ReportStore, data: object): Promise<void>;
  exportExcelBC07(data: object): Promise<void>;

  // Báo cáo 8 mới
  getDataBC08(store: ReportStore, data: object): Promise<void>;
  exportExcelBC08(data: object): Promise<void>;

  // báo cáo 9
  exportExcelBC09(data: object): Promise<void>;

  // Báo cáo 4 mới
  getDataBC04(store: ReportStore, data: object): Promise<void>;
  exportExcelBC04(data: object): Promise<void>;

  // Báo cáo 5 mới
  getDataBC05(store: ReportStore, data: object): Promise<void>;
  exportExcelBC05(data: object): Promise<void>;
  // ================================================================================================
  //------BC11 --------------------------------------------------------------------------
  getListQCProction(store: ReportStore, data: object): Promise<void>;
  getDetailQCProction(store: ReportStore, woCode: string, stepCode: string): Promise<void>;
  //----------------------XXX------------------------------------------------------------
  //------BC10 --------------------------------------------------------------------------
  getWoComplete(store: ReportStore, data: object): Promise<void>;
  //----------------------XXX------------------------------------------------------------
  // BC05
  getBC05(store: ReportStore, data: object): Promise<void>;
  // BC05 details
  getBC05Details(store: ReportStore, WorkShopId: string): Promise<void>;
  // BC04
  getBC04(store: ReportStore, data: object): Promise<void>;
  // bc 04 to san xuat
  getListDepartment(store: ReportStore): Promise<void>;
}

export function createReportPresenter({ reportServices }: { reportServices: IReportService }): IReportResenter {
  return {
    createStore: (): ReportStore =>
      observable({
        equipmentStatus: {
          data: [],
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        },
        listKeynValue: {
          data: [],
          message: '',
          isSuccess: false,
        },
        WorkShopEquipmentsStatus: {
          data: [],
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        },
        ProductionPlan: {
          data: undefined,
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        },
        ListEquipmentOfBarCode: {
          code: 0,
          data: [],
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        },
        UpdateResponse: {
          message: '',
          isSuccess: false,
        },
        SaveResponse: {
          message: '',
          isSuccess: false,
        },
        EquipmentStatusReportResponse: {
          code: 0,
          data: undefined,
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        stateItemId: [],
        SumaryProductionReportResponse: {
          code: 0,
          data: undefined,
          dataChart: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        //bc06
        BC06DetailsResponse: {
          code: 0,
          data: undefined,
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        BC02Response: {
          isSuccess: false,
          message: '',
          data: undefined,
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        // BC02 popup
        BC02PopupResponse: {
          isSuccess: false,
          message: '',
          data: undefined,
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        // BC02 dropdown
        BC02DropdownResponse: {
          isSuccess: false,
          message: '',
          data: [],
        },

        // BC03 Báo cáo cảnh báo tiến độ đơn hàng
        BC03Response: {
          isSuccess: false,
          message: '',
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        TimeMachineTroubledReportRespone: {
          code: 0,
          data: [],
          dataChart: undefined,
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        //BC07 DETAILS
        DetailTimeMachineTroubledReportResponse: {
          code: 0,
          data: undefined,
          dataChart: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        //BC08
        BC08Response: {
          code: 0,
          data: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        //BC09

        BC09CompleteRateStageResponse: {
          code: 0,
          data: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        // =======================================================================================================
        // ======BÁO CÁO MỚI
        // BC 7 (mới)
        BC07Response: {
          isSuccess: false,
          message: '',
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        // BC 8 (mới)
        BC08NewResponse: {
          isSuccess: false,
          message: '',
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        // BC 4 (mới)
        BC04NewResponse: {
          isSuccess: false,
          message: '',
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        // BC 5 (mới)
        BC05NewResponse: {
          isSuccess: false,
          message: '',
          data: undefined,
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        // ===========================================================================================================
        //--BC11 ---------------------------------------------------------------------------
        qcProcductionResponse: {
          isSuccess: false,
          data: [],
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        detailQCResponse: {
          data: [],
          isSuccess: false,
        },
        //-------------------------XXX-----------------------------------------------------
        //-----BC10 ----------------------------------------------------------------
        woCompleteResponse: {
          isSuccess: false,
          data: [],
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        //-------------------------XXX----------------------------------------------------
        // BC05
        BC05Response: {
          code: 0,
          data: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        //BC005 details
        BC05DetailsResponse: {
          code: 0,
          data: [],
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        // BC05
        BC04Response: {
          code: 0,
          data: [],
          dataChart: undefined,
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        // bc 04
        DepartmentResponse: {
          data: [],
          message: '',
          isSuccess: false,
        },
      }),
    getEquipmentStatusReport: async (store, data) => {
      try {
        const result = await reportServices.getEquipmentStatusReport(data);
        runInAction(() => {
          store.equipmentStatus.data = result.data;
          store.equipmentStatus.isSuccess = result.isSuccess;
          store.equipmentStatus.message = result.message;
          store.equipmentStatus.pagesCount = result.pagesCount;
          store.equipmentStatus.recordsTotal = result.recordsTotal;
          store.equipmentStatus.resultsCount = result.resultsCount;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getListWorkShop: async (store) => {
      try {
        const result = await reportServices.getListWorkShop();
        runInAction(() => {
          store.listKeynValue = result;
        });
      } catch (error) {
        console.log(error);
      }
    },
    exportExcelBC11: async () => {
      try {
        await reportServices.exportExcelBC11();
      } catch (error) {
        console.log(error);
      }
    },
    getListDropdownEquipmentName: async (store, key) => {
      try {
        const result = await reportServices.getListDropdownEquipmentName(key);
        runInAction(() => {
          store.listKeynValue.data = result.data;
          store.listKeynValue.isSuccess = result.isSuccess;
          store.listKeynValue.message = result.message;
        });
      } catch (err) { }
    },
    WorkShopEquipments: async (store, WorkShopId, MachineGroup, MachineStatus, EuipmentName, Actived, equipmentCardIds) => {
      try {
        const result = await reportServices.getWorkShopEquipments(
          WorkShopId,
          MachineGroup,
          MachineStatus,
          EuipmentName,
          Actived,
          equipmentCardIds
        );
        runInAction(() => {
          store.WorkShopEquipmentsStatus.data = result.data;
          store.WorkShopEquipmentsStatus.isSuccess = result.isSuccess;
          store.WorkShopEquipmentsStatus.message = result.message;
          store.WorkShopEquipmentsStatus.pagesCount = result.pagesCount;
          store.WorkShopEquipmentsStatus.recordsTotal = result.recordsTotal;
          store.WorkShopEquipmentsStatus.resultsCount = result.resultsCount;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getDropdownDepartment: async (store, id) => {
      try {
        const result = await reportServices.getDropdownDepartment(id ? id : '');
        runInAction(() => {
          store.listKeynValue.data = result.data;
          store.listKeynValue.message = result.message;
          store.listKeynValue.isSuccess = result.isSuccess;
        });
      } catch (error) { }
    },
    getListEquipmentOfBarCode: async (store, id) => {
      try {
        const result = await reportServices.getListEquipmentOfBarCode(id);
        runInAction(() => {
          store.ListEquipmentOfBarCode.code = result.code;
          store.ListEquipmentOfBarCode.data = result.data;
          store.ListEquipmentOfBarCode.isSuccess = result.isSuccess;
          store.ListEquipmentOfBarCode.message = result.message;
          store.ListEquipmentOfBarCode.pagesCount = result.pagesCount;
          store.ListEquipmentOfBarCode.recordsTotal = result.recordsTotal;
          store.ListEquipmentOfBarCode.resultsCount = result.resultsCount;
        });
      } catch { }
    },
    updateBarCodeNameEquip: async (store, data) => {
      try {
        const result = await reportServices.updateBarCodeNameEquip(data);
        runInAction(() => {
          store.UpdateResponse.isSuccess = result.isSuccess;
          store.UpdateResponse.message = result.message;
        });
      } catch (error) { }
    },
    updateIndexBarcode: async (store, data) => {
      try {
        const result = await reportServices.updateIndexBarcode(data);
        runInAction(() => {
          store.UpdateResponse.isSuccess = result.isSuccess;
          store.UpdateResponse.message = result.message;
        });
      } catch { }
    },
    getListEquipmentStatus: async (store) => {
      try {
        const result = await reportServices.getListEquimentStatus();
        runInAction(() => {
          store.listKeynValue.data = result.data;
          store.listKeynValue.isSuccess = result.isSuccess;
          store.listKeynValue.message = result.message;
        });
      } catch { }
    },
    getListGroupEquip: async (store, listId) => {
      try {
        const result = await reportServices.getListGroupEquip(listId);
        runInAction(() => {
          store.listKeynValue.data = result.data;
          store.listKeynValue.isSuccess = result.isSuccess;
          store.listKeynValue.message = result.message;
        });
      } catch { }
    },
    getEquipmentStatusById: async (store, data) => {
      try {
        const result = await reportServices.getEquipmentStatusById(data);
        runInAction(() => {
          store.EquipmentStatusReportResponse.data = result.data;
          store.EquipmentStatusReportResponse.isSuccess = result.isSuccess;
          store.EquipmentStatusReportResponse.message = result.message;
        });
      } catch { }
    },
    getListEquipCard: async (store) => {
      try {
        const result = await reportServices.getListEquipCard();
        runInAction(() => {
          store.listKeynValue.data = result.data;
          store.listKeynValue.isSuccess = result.isSuccess;
          store.listKeynValue.message = result.message;
        });
      } catch { }
    },
    exportExcelBC01: async (data: object) => {
      try {
        await reportServices.exportExcelBC01(data);
      } catch (error) {
        console.log(error);
      }
    },
    // save chọn máy thực hiện báo cáo 02 (BC02)
    saveChooseEquipment: async (store, data) => {
      try {
        const result = await reportServices.saveChooseEquipment(data);
        runInAction(() => {
          store.SaveResponse.isSuccess = result.isSuccess;
          store.SaveResponse.message = result.message;
        });
      } catch (error) { }
    },
    // Sắp xếp lsx đang thực hiện (BC02)
    sortRowBC02Selected: async (store, data) => {
      try {
        const result = await reportServices.sortRowBC02Selected(data);
        runInAction(() => {
          store.SaveResponse.isSuccess = result.isSuccess;
          store.SaveResponse.message = result.message;
        });
      } catch (error) { }
    },
    updateWoCard: async (store, data) => {
      try {
        const result = await reportServices.updateWoCard(data);
        runInAction(() => {
          store.UpdateResponse.isSuccess = result.isSuccess;
          store.UpdateResponse.message = result.message;
        });
      } catch (error) { }
    },
    setItemId: async (store, id) => {
      try {
        runInAction(() => {
          store.stateItemId = id;
        });
      } catch (error) { }
    },
    //BC06
    sumaryProductionReport: async (store, data) => {
      try {
        const result = await reportServices.sumaryProductionReport(data);
        runInAction(() => {
          store.SumaryProductionReportResponse.isSuccess = result.isSuccess;
          store.SumaryProductionReportResponse.code = result.code;
          store.SumaryProductionReportResponse.data = result.data;
          store.SumaryProductionReportResponse.message = result.message;
          store.SumaryProductionReportResponse.pagesCount = result.pagesCount;
          store.SumaryProductionReportResponse.recordsTotal = result.recordsTotal;
          store.SumaryProductionReportResponse.resultsCount = result.resultsCount;
        });
      } catch (error) { }
    },
    //bc06 details
    getBC06Details: async (store, equipId, fromTime, toTime) => {
      try {
        const result = await reportServices.getBC06Details(equipId, fromTime, toTime);
        runInAction(() => {
          store.BC06DetailsResponse.isSuccess = result.isSuccess;
          store.BC06DetailsResponse.code = result.code;
          store.BC06DetailsResponse.data = result.data;
          store.BC06DetailsResponse.message = result.message;
          store.BC06DetailsResponse.pagesCount = result.pagesCount;
          store.BC06DetailsResponse.recordsTotal = result.recordsTotal;
          store.BC06DetailsResponse.resultsCount = result.resultsCount;
        });
      } catch (error) { }
    },
    // =====================================================================================
    // =====================================================================================
    //BC02
    getBC02: async (store, data) => {
      try {
        const result = await reportServices.getBC02(data);
        runInAction(() => {
          store.BC02Response.data = result.data;
          store.BC02Response.message = result.message;
          store.BC02Response.isSuccess = result.isSuccess;
          store.BC02Response.paging = {
            totalCount: result.paging?.totalCount,
            totalPage: result.paging?.totalPage,
            pageSize: result.paging?.pageSize,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    // export data bc02
    exportDataBC02: async (data) => {
      try {
        await reportServices.exportDataBC02(data);
      } catch (error) {
        console.log(error);
      }
    },
    // BC02 popup
    getDataPopupBC02: async (store, id) => {
      try {
        const result = await reportServices.getDataPopupBC02(id);
        runInAction(() => {
          store.BC02PopupResponse.data = result.data;
          store.BC02PopupResponse.message = result.message;
          store.BC02PopupResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // BC02 dropdown
    getDropdownBC02: async (store, stepCode, equipmentName) => {
      try {
        const result = await reportServices.getDataDropDown(stepCode, equipmentName);
        runInAction(() => {
          store.BC02DropdownResponse.data = result.data;
          store.BC02DropdownResponse.message = result.message;
          store.BC02DropdownResponse.isSuccess = result.isSuccess;
        });
      } catch (error) {
        console.log(error);
      }
    },
    // =====================================================================================
    // =====================================================================================

    //BC03
    getDataBC03: async (store, data) => {
      try {
        const result = await reportServices.getDataBC03(data);
        runInAction(() => {
          store.BC03Response.data = result.data;
          store.BC03Response.message = result.message;
          store.BC03Response.isSuccess = result.isSuccess;
          store.BC03Response.paging = {
            totalCount: result.paging?.totalCount,
            totalPage: result.paging?.totalPage,
            pageSize: result.paging?.pageSize,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    exportExcelBC03: async (data: object) => {
      try {
        await reportServices.exportExcelBC03(data);
      } catch (error) {
        console.log(error);
      }
    },

    // bc07
    getBC07TimeMachineTroubledReport: async (store, data) => {
      try {
        const result = await reportServices.getBC07TimeMachineTroubledReport(data);
        runInAction(() => {
          store.TimeMachineTroubledReportRespone.code = result.code;
          store.TimeMachineTroubledReportRespone.data = result.data;
          store.TimeMachineTroubledReportRespone.dataChart = result.dataChart;
          store.TimeMachineTroubledReportRespone.isSuccess = result.isSuccess;
          store.TimeMachineTroubledReportRespone.message = result.message;
          store.TimeMachineTroubledReportRespone.pagesCount = result.pagesCount;
          store.TimeMachineTroubledReportRespone.recordsTotal = result.recordsTotal;
          store.TimeMachineTroubledReportRespone.resultsCount = result.resultsCount;
        });
      } catch (error) { }
    },
    getBC07DetailTimeMachineTroubledReport: async (store, EquipmentCardId, FromTime, ToTime) => {
      try {
        const rs = await reportServices.getBC07DetailTimeMachineTroubledReport(EquipmentCardId, FromTime, ToTime);
        runInAction(() => {
          store.DetailTimeMachineTroubledReportResponse.code = rs.code;
          store.DetailTimeMachineTroubledReportResponse.data = rs.data;
          store.DetailTimeMachineTroubledReportResponse.isSuccess = rs.isSuccess;
        });
      } catch (error) { }
    },
    //BC07 list equip
    getBC07ListEquipcard: async (store, data) => {
      try {
        const rs = await reportServices.getBC07ListEquipcard(data);
        runInAction(() => {
          store.listKeynValue.data = rs.data;
          store.listKeynValue.message = rs.message;
          store.listKeynValue.isSuccess = rs.isSuccess;
        });
      } catch { }
    },
    // BC08
    getBC08: async (store, data) => {
      try {
        const result = await reportServices.getBC08(data);
        runInAction(() => {
          store.BC08Response.isSuccess = result.isSuccess;
          store.BC08Response.data = result.data;
          store.BC08Response.message = result.message;
          store.BC08Response.pagesCount = result.pagesCount ? result.pagesCount : 0;
          store.BC08Response.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.BC08Response.resultsCount = result.resultsCount ? result.resultsCount : 0;
        });
      } catch { }
    },

    //bc09
    getBC09CompleteRateStage: async (store: ReportStore, data) => {
      try {
        const result = await reportServices.getBC09CompleteRateStage(data);
        runInAction(() => {
          store.BC09CompleteRateStageResponse.isSuccess = result.isSuccess;
          store.BC09CompleteRateStageResponse.data = result.data;
          store.BC09CompleteRateStageResponse.pagesCount = result.pagesCount ? result.pagesCount : 0;
          store.BC09CompleteRateStageResponse.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.BC09CompleteRateStageResponse.resultsCount = result.resultsCount ? result.resultsCount : 0;
        });
      } catch { }
    },
    //bc09
    getDropdownWo: async (store: ReportStore, woCode: string) => {
      try {
        const result = await reportServices.getDropdownWo(woCode);
        runInAction(() => {
          store.listKeynValue.data = result.data;
          store.listKeynValue.message = result.message;
          store.listKeynValue.isSuccess = result.isSuccess;
        });
      } catch { }
    },
    // =============================================================================================================
    //------------------ BÁO CÁO MỚI
    // BC07 (mới ) gộp bc08 + bc09
    getDataBC07: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getDataBC07(data);
        runInAction(() => {
          store.BC07Response.data = result.data;
          store.BC07Response.message = result.message;
          store.BC07Response.isSuccess = result.isSuccess;
          store.BC07Response.paging = {
            totalCount: result.paging?.totalCount,
            totalPage: result.paging?.totalPage,
            pageSize: result.paging?.pageSize,
          };
        });
      } catch { }
    },
    exportExcelBC07: async (data: object) => {
      try {
        await reportServices.exportExcelBC07(data);
      } catch (error) {
        console.log(error);
      }
    },

    // BC08 (mới ) thay cho báo cáo 10
    getDataBC08: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getDataBC08(data);
        runInAction(() => {
          store.BC08NewResponse.data = result.data;
          store.BC08NewResponse.message = result.message;
          store.BC08NewResponse.isSuccess = result.isSuccess;
          store.BC08NewResponse.paging = {
            totalCount: result.paging?.totalCount,
            totalPage: result.paging?.totalPage,
            pageSize: result.paging?.pageSize,
          };
        });
      } catch { }
    },

    exportExcelBC08: async (data: object) => {
      try {
        await reportServices.exportExcelBC08(data);
      } catch (error) {
        console.log(error);
      }
    },
    exportExcelBC09: async (data: object) => {
      try {
        await reportServices.exportExcelBC09(data);
      } catch (error) {
        console.log(error);
      }
    },

    // BC04 (mới ) thay cho báo cáo 10
    getDataBC04: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getDataBC04(data);
        runInAction(() => {
          store.BC04NewResponse.data = result.data;
          store.BC04NewResponse.message = result.message;
          store.BC04NewResponse.isSuccess = result.isSuccess;
          store.BC04NewResponse.paging = {
            totalCount: result.paging?.totalCount,
            totalPage: result.paging?.totalPage,
            pageSize: result.paging?.pageSize,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    exportExcelBC04: async (data: object) => {
      try {
        await reportServices.exportExcelBC04(data);
      } catch (error) {
        console.log(error);
      }
    },

    // BC05 (mới )
    getDataBC05: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getDataBC05(data);
        runInAction(() => {
          store.BC05NewResponse.data = result.data;
          store.BC05NewResponse.message = result.message;
          store.BC05NewResponse.isSuccess = result.isSuccess;
          store.BC05NewResponse.paging = {
            totalCount: result.paging?.totalCount,
            totalPage: result.paging?.totalPage,
            pageSize: result.paging?.pageSize,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    exportExcelBC05: async (data: object) => {
      try {
        await reportServices.exportExcelBC05(data);
      } catch (error) {
        console.log(error);
      }
    },

    // ===============================================================================================

    //----BC11-------------------------------------------------------------------------------------------
    getListQCProction: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getListQCProduction(data);
        runInAction(() => {
          store.qcProcductionResponse.isSuccess = result.isSuccess;
          store.qcProcductionResponse.data = result.data;
          store.qcProcductionResponse.pagesCount = result.pagesCount ? result.pagesCount : 0;
          store.qcProcductionResponse.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.qcProcductionResponse.resultsCount = result.resultsCount ? result.resultsCount : 0;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getDetailQCProction: async (store: ReportStore, woCode: string, stepCode: string) => {
      try {
        const result = await reportServices.getDetailQCProduction(woCode, stepCode);
        runInAction(() => {
          store.detailQCResponse.isSuccess = result.isSuccess;
          store.detailQCResponse.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //-------------------------------XXX-----------------------------------------------------------------
    // ------BC10------------------------------------------------------------------------------------
    getWoComplete: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getWoComplete(data);
        runInAction(() => {
          store.woCompleteResponse.isSuccess = result.isSuccess;
          store.woCompleteResponse.data = result.data;
          store.woCompleteResponse.pagesCount = result.pagesCount ? result.pagesCount : 0;
          store.woCompleteResponse.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.woCompleteResponse.resultsCount = result.resultsCount ? result.resultsCount : 0;
        });
      } catch (error) {
        console.log(error);
      }
    },
    //-----------------------XXX----------------------------------------------------------------
    // bc05
    getBC05: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getBC05(data);
        runInAction(() => {
          store.BC05Response.isSuccess = result.isSuccess;
          store.BC05Response.data = result.data;
          store.BC05Response.pagesCount = result.pagesCount ? result.pagesCount : 0;
          store.BC05Response.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.BC05Response.resultsCount = result.resultsCount ? result.resultsCount : 0;
        });
      } catch { }
    },
    // bc05
    getBC05Details: async (store: ReportStore, WorkShopId: string) => {
      try {
        const result = await reportServices.getBC05Details(WorkShopId);
        runInAction(() => {
          store.BC05DetailsResponse.isSuccess = result.isSuccess;
          store.BC05DetailsResponse.data = result.data;
          store.BC05DetailsResponse.pagesCount = result.pagesCount ? result.pagesCount : 0;
          store.BC05DetailsResponse.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.BC05DetailsResponse.resultsCount = result.resultsCount ? result.resultsCount : 0;
        });
      } catch { }
    },
    // bc04
    getBC04: async (store: ReportStore, data: object) => {
      try {
        const result = await reportServices.getBC04(data);
        runInAction(() => {
          store.BC04Response.isSuccess = result.isSuccess;
          store.BC04Response.data = result.data;
          store.BC04Response.dataChart = result.dataChart;
          store.BC04Response.pagesCount = result.pagesCount ? result.pagesCount : 0;
          store.BC04Response.recordsTotal = result.recordsTotal ? result.recordsTotal : 0;
          store.BC04Response.resultsCount = result.resultsCount ? result.resultsCount : 0;
        });
      } catch { }
    },
    // bc04 to san xuat
    getListDepartment: async (store: ReportStore) => {
      const result = await reportServices.getListDepartment();
      runInAction(() => {
        store.DepartmentResponse.data = result.data;
        store.DepartmentResponse.message = result.message;
        store.DepartmentResponse.isSuccess = result.isSuccess;
      });
    },
  };
}
